module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/quinto-andar.f6e66858.svg";